<template>
    <div class="LayoutHeaderBox">
        <div class="LayoutHeaderTop">
            <div class="headerLogoBox">
                <a href="https://www.020leader.com" target="_blank" class="logoBox">
                    <img src="../../assets/images/icon/logo.png" class="logoImg"/>
                </a>
            </div>
            <div class="headerPhoneBox">
                <img src="../../assets/images/icon/phone.png" class="headerPhoneIcon"/>
                <div class="phoneBox">
                    <span class="bigPhone">400-0827-880</span>
                    <br/>
                    <span class="smallPhone">售后电话:400-0827-880</span>
                </div>
            </div>
        </div>
        <div class="LayoutHeader">
            <div class="headerLeft">
                <!-- <a href="https://www.020leader.com" target="_blank" class="logoBox">
                    <img src="../../assets/images/icon/logo.png" class="logoImg"/>
                </a> -->
            </div>
            <div class="headerContent">
                <div
                    v-for="(item, index) in this.list"
                    :key="item.index"
                    :class="isActiveNum === index ? 'active menuItemBox':'menuItemBox'"
                >
                    <div class="menuItem" @click="btnMenu(index)">
                        <div :class="isActiveNum === index ? 'isActive linkBox' : 'linkBox'" > {{ item.menu }} </div>
                    </div>
                </div>
            </div>
            <div class="headerRight">
                <a href="https://www9.53kf.com/webCompany.php?arg=10228472&kf_sign=zMzNDMTY3MgzNjEyMTg1MTg5NTcwMDA3NzIyMjg0NzI%253D&style=1" target="_blank" class="consult">加盟</a>
            </div>
        </div>
        
    </div>
</template>

<script>

export default {
    name:'LayoutHeader',
    components: {},
    props:{},
    data() {
        return {
            isActiveNum: 0,
            list:[
                { menu: "首页", link: "/home" },
                { menu: "关于移领", link: "/about" },
                { menu: "产品中心", link: "/product-introduction" },
                { menu: "行业方案", link: "/scheme" },
                { menu: "合作伙伴", link: "/partner" },
                
            ]
        };
    },
    computed: {},
    watch: {},
    created() {
        let menuActiveNum = sessionStorage.getItem('menuActiveNum')
        menuActiveNum && (this.isActiveNum = +menuActiveNum)
        console.log(menuActiveNum,'menuActiveNum');
    },
    mounted() {
        
    },
    methods: {
        btnMenu(index){
            if(this.list[index].link.indexOf('://') !== -1) return window.location.href = this.list[index].link
            if(sessionStorage.getItem('menuActiveNum') && sessionStorage.getItem('menuActiveNum') == index) return
            sessionStorage.setItem('menuActiveNum',index)
            this.isActiveNum = index
            this.$router.push(this.list[index].link)
        }
    },
}
</script>
<style  scoped>
ul,ol{list-style: none;}
.active{
    border-bottom: 2px solid #ff8118;
}
.LayoutHeaderBox{
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
}
.LayoutHeaderTop{
    height: 52px;
    background-color: #fff;
    display: flex;
    justify-content: space-around;
    align-items: center;
    
}
.LayoutHeader{
    width: 100%;
    height: 48px;
    padding: 0 40px;
    background-color: #333333;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
}
.headerContent{
    width: 60%;
    min-width: 500px;
    height: 48px;
    display: flex;
    justify-content: space-around;
    align-items: center;
}
.menuItemBox{
    padding: 0 20px;
    height: 100%;
    box-sizing: border-box;
}
.menuItem{
    width: 100%;
    height: 100%;
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
}
.logoBox{
    display: block;
    align-items: center;
}
.logoImg{
    height: 28px;
    margin-top: 5px;
}
.linkBox{
    width: 100%;
    height: 100%;
    font-size: 14px;
    line-height: 48px;
    color: #fff;
    text-decoration: none;
}
.consult{
    white-space: nowrap;
    font-size: 14px;
    color: #fff;
    text-decoration: none;
    padding: 5px 20px;
    border: 1px solid #fff;
    border-radius: 2px 2px;
}
.headerPhoneBox{
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.headerPhoneIcon{
    width: 32px;
    margin-right: 10px;
}
.phoneBox{
    text-align: left;
}
.bigPhone{
    font-size: 20px;
    color: #ff8118;
}
.smallPhone{
    font-size: 12px;
}
</style>